enum DigitalCiSignatureSignTypeEnum {
    DEFAULT = 0,
    TOGETHER = 1,
    SEPARATED = 2,
  }

  export default DigitalCiSignatureSignTypeEnum;